import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";


const SignatureInput = ({ value, onChange, label = "Server Signature (Optional)" }) => {
    const signaturePadRef = useRef(null);
    const [mode, setMode] = useState(""); // "upload" | "pad" | ""
    const [pendingSignature, setPendingSignature] = useState(null);
    const user = JSON.parse(localStorage.getItem('user'));
    const PlanType = user?.organization?.planType || 'standard';
    console.log("User Plan Type:", PlanType);


    const handleModeSelect = (selected) => {
        setMode(selected);
        setPendingSignature(null);
        if (selected !== "pad") {
            // If switching away from pad, ensure canvas is reset
            signaturePadRef.current?.clear();
        }
    };

    // Convert drawn signature to file
    const confirmSignature = async () => {
        const canvas = signaturePadRef.current.getCanvas();
        const dataURL = canvas.toDataURL("image/png");
        const res = await fetch(dataURL);
        const blob = await res.blob();
        const file = new File([blob], "signature.png", { type: "image/png" });
        onChange(file);
        setPendingSignature(file);
    };

    const dismissPad = () => {
        setMode("");
        setPendingSignature(null);
        signaturePadRef.current.clear();
    };

    return (
        <div className="border-t pt-3">
            <p className="text-sm font-semibold text-gray-700">{label}</p>

            {/* Mode Selection */}
            <div className="mt-2 flex gap-4 text-sm">
                <label className="flex items-center gap-1">
                    <input
                        type="radio"
                        checked={mode === "upload"}
                        onChange={() => handleModeSelect("upload")}
                    />
                    Upload Signature Image
                </label>
            

                    <label className="flex items-center gap-1">
                        <input
                            type="radio"
                            checked={mode === "pad"}
                            onChange={() => handleModeSelect("pad")}
                            disabled={PlanType != 'elite'}
                        />
                        <b className={`${PlanType == "elite" ? "text-gray-700" : "text-red-300"}`}>Draw Using Digital Signature Pad</b> {(PlanType == 'standard' || PlanType == "pro") ? '(For Elite Subscribers only)' : ''}
                    </label>
                
            </div>

            {/* Upload Field */}
            {mode === "upload" && (
                <input
                    type="file"
                    className="mt-3 text-sm border p-1 w-full"
                    onChange={(e) => onChange(e.target.files[0])}
                />
            )}

            {/* Signature Pad */}
            {mode === "pad" && (
                <div className="mt-3 p-3 bg-white border rounded shadow-sm space-y-2">
                    <SignatureCanvas
                        ref={signaturePadRef}
                        penColor="black"
                        canvasProps={{ className: "border w-full h-40 rounded bg-white" }}
                    />

                    <div className="flex gap-2">
                        <button
                            type="button"
                            className="px-3 py-1 bg-gray-500 text-white rounded text-sm"
                            onClick={() => signaturePadRef.current.clear()}
                        >
                            Clear
                        </button>

                        <button
                            type="button"
                            className="px-3 py-1 bg-green-600 text-white rounded text-sm"
                            onClick={confirmSignature}
                        >
                            Confirm Signature
                        </button>

                        <button
                            type="button"
                            className="px-3 py-1 bg-red-500 text-white rounded text-sm"
                            onClick={dismissPad}
                        >
                            Dismiss
                        </button>
                    </div>
                </div>
            )}

            {/* Preview */}
            {(value || pendingSignature) && (
                <div className="mt-2 flex items-center gap-2">
                    <img
                        src={URL.createObjectURL(value || pendingSignature)}
                        alt="signature preview"
                        className="h-14 border rounded bg-white"
                    />
                    <span className="text-xs text-green-700 font-medium">Signature Confirmed</span>
                </div>
            )}
        </div>
    );
};

export default SignatureInput;
